import  { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../Dashbaord/Layout.js/Layout';
import {
    FaPrint, FaDownload, FaArrowLeft,
    FaFilePdf
} from 'react-icons/fa';
import {
    Container, Row, Col, Button, ButtonGroup,
    Alert, Spinner
} from 'react-bootstrap';
import { getBillById } from '../../../services/bills.services';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import urdulogo from '../../../assets/urdu.png';
import englogo from '../../../assets/english.png';
import { colors } from '../../../utils/Colors';

const ViewBill = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [bill, setBill] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [downloading, setDownloading] = useState(false);

    useEffect(() => {
        fetchBill();
    }, [id]);

    const fetchBill = async () => {
        try {
            setLoading(true);
            const response = await getBillById(id);
            console.log(response.data)
            if (response.data.success) {
                setBill(response.data.data);
            } else {
                setError('Bill not found');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to load bill details');
        } finally {
            setLoading(false);
        }
    };

    const formatCurrency = (amount) => {
        if (!amount) return 'Rs: 0';
        return `Rs: ${new Intl.NumberFormat('en-PK').format(amount)}`;
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-PK', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

const handlePrint = () => {
    const billContent = document.getElementById('bill-content');
    if (!billContent) return;

    const printWindow = window.open('', '_blank');
    if (!printWindow) return alert('Please allow pop-ups for printing');

 
    const a4HeightPx = 1122; 
    const contentHeight = billContent.scrollHeight;
    const scale = contentHeight > a4HeightPx ? a4HeightPx / contentHeight : 1;

    printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <title>Print Bill</title>
            <style>
                body {
                    margin: 0;
                    padding: 0;
                    font-family: Arial, sans-serif;
                    background: white;
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }
                #watermark {
                    position: fixed;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 500px;
                    height: 500px;
                    background-image: url('${urdulogo}');
                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center;
                    opacity: 0.15;
                    pointer-events: none;
                    z-index: 0;
                }
                #bill-container {
                    position: relative;
                    z-index: 1;
                    transform-origin: top center;
                    transform: scale(${scale});
                }
            </style>
        </head>
        <body>
            <div id="watermark"></div>
            <div id="bill-container">
                ${billContent.innerHTML}
            </div>
        </body>
        </html>
    `);

    setTimeout(() => {
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    }, 300);
};



     const handleDownloadPDF = async () => {
        try {
            setDownloading(true);
            
            const billContent = document.getElementById('bill-content');
            
          
            const pdfContainer = document.createElement('div');
            pdfContainer.id = 'pdf-container';
            pdfContainer.style.cssText = `
                position: fixed;
                top: -10000px;
                left: 0;
                width: 210mm;
                min-height: 297mm;
                background: white;
                padding: 10mm;
                box-sizing: border-box;
            `;
            
            
            const watermark = document.createElement('div');
            watermark.style.cssText = `
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 500px;
                height: 500px;
                z-index: 0;
                pointer-events: none;
            `;
            
            const watermarkImg = document.createElement('img');
            watermarkImg.src = urdulogo;
            watermarkImg.crossOrigin = 'anonymous';
            watermarkImg.style.cssText = `
                width: 100%;
                height: 100%;
                object-fit: contain;
                opacity: 0.06;
            `;
            
            watermark.appendChild(watermarkImg);
            pdfContainer.appendChild(watermark);
            
          
            const contentClone = billContent.cloneNode(true);
            contentClone.style.cssText = `
                position: relative;
                z-index: 1;
                background: transparent;
                transform: scale(0.98);
                transform-origin: top center;
            `;
            
            pdfContainer.appendChild(contentClone);
            document.body.appendChild(pdfContainer);
            
           
            await new Promise(resolve => setTimeout(resolve, 1500));
            
           
            if (!watermarkImg.complete) {
                await new Promise((resolve) => {
                    watermarkImg.onload = resolve;
                    watermarkImg.onerror = resolve;
                });
            }
            
           
            const canvas = await html2canvas(pdfContainer, {
                scale: 2.5,
                useCORS: true,
                allowTaint: true,
                logging: false,
                backgroundColor: '#ffffff',
                imageTimeout: 0,
                onclone: (clonedDoc) => {
                    const container = clonedDoc.getElementById('pdf-container');
                    if (container) {
                        container.style.display = 'block';
                        container.style.visibility = 'visible';
                        
                        
                        const imgs = container.getElementsByTagName('img');
                        for (let img of imgs) {
                            img.style.opacity = img.src.includes('urdu') ? '0.15' : '1';
                        }
                    }
                }
            });
            
            
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4',
                compress: true
            });
            
            const imgWidth = 210;
            const imgHeight = 297;
            
            
            const imgData = canvas.toDataURL('image/jpeg', 0.95);
            pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight, '', 'FAST');
            
            
            const fileName = bill ? `Bill-${bill.refNo || bill._id}.pdf` : 'bill.pdf';
            pdf.save(fileName);
            
           
            document.body.removeChild(pdfContainer);
            
        } catch (err) {
            console.error('PDF generation error:', err);
            alert('Failed to generate PDF. Please try again.');
        } finally {
            setDownloading(false);
        }
    };


    if (loading) {
        return (
            <Layout>
                <Container className="py-5 text-center">
                    <Spinner animation="border" variant="primary" />
                    <p className="mt-3">Loading bill details...</p>
                </Container>
            </Layout>
        );
    }

    if (error || !bill) {
        return (
            <Layout>
                <Container className="py-5">
                    <Alert variant="danger">
                        <h4>Error</h4>
                        <p>{error || 'Bill not found'}</p>
                        <Button
                            variant="outline-danger"
                            onClick={() => navigate('/admin/dashboard/bills')}
                        >
                            <FaArrowLeft className="me-2" />
                            Back to Bills
                        </Button>
                    </Alert>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container fluid className="p-4">

                <div className="d-print-none mb-4 p-3 text-white rounded" style={{ backgroundColor: colors.TABLE_HEADERS }}>
                    <Row className="align-items-center">
                        <Col md={4}>
                            <h4 className="mb-0">
                                <FaFilePdf className="me-2" />
                                Bill Preview
                            </h4>
                        </Col>
                        <Col md={8} className="text-end">
                            <ButtonGroup>
                                <Button
                                    variant="outline-light"
                                    onClick={() => navigate('/admin/dashboard/bills-list')}
                                    className="me-2"
                                >
                                    <FaArrowLeft className="me-2" />
                                    Back
                                </Button>
                                <Button
                                    variant="outline-light"
                                    onClick={handlePrint}
                                    className="me-2"
                                >
                                    <FaPrint className="me-2" />
                                    Print
                                </Button>
                                <Button
                                    variant="outline-light"
                                    onClick={handleDownloadPDF}
                                    disabled={downloading}
                                >
                                    {downloading ? (
                                        <>
                                            <Spinner size="sm" className="me-2" />
                                            Downloading...
                                        </>
                                    ) : (
                                        <>
                                            <FaDownload className="me-2" />
                                            Download PDF
                                        </>
                                    )}
                                </Button>
                            </ButtonGroup>
                        </Col>
                    </Row>
                </div>

                <div id="bill-content" style={{
                    fontFamily: 'Arial, sans-serif',
                    backgroundColor: '#fff',
                    padding: '15px 20px',
                    border: '1px solid #ccc',
                    maxWidth: '900px',
                    margin: 'auto',
                    position: 'relative',
                    minHeight: '1100px',
                    zIndex: 1
                }}>

                    <div style={{
                        textAlign: 'center',
                        marginBottom: '10px'
                    }}>
                        <img
                            src={englogo}
                            alt="RONAQ BANQUET"
                            style={{
                                width: '150px',
                                height: 'auto',
                            }}
                        />
                    </div>


                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '5px',
                        paddingBottom: '5px',
                        borderBottom: '1px solid #ccc'
                    }}>

                        <h2 style={{
                            textAlign: 'center',
                            textTransform: 'uppercase',
                            margin: '3px 0 8px',
                            letterSpacing: '1px',
                            fontSize: '18px'
                        }}>
                            Guest Form Registration
                        </h2>



                        <div style={{
                            fontSize: '16px',
                            fontWeight: 'bold'
                        }}>
                            Ref No: <strong>{bill.refNo || 'N/A'}</strong>
                        </div>
                    </div>


                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '10px',
                        marginBottom: '12px',
                        fontSize: '13px'
                    }}>
                        {/* Left Column */}
                        <div>
                            <div style={{ marginBottom: '5px' }}>
                                <label style={{ display: 'inline-block', width: '140px', fontSize: '13px' }}>Name:</label>
                                <span style={{ textDecoration: 'none' }}>{bill.eventDetails?.name || '____________________________'}</span>
                            </div>
                            <div style={{ marginBottom: '5px' }}>
                                <label style={{ display: 'inline-block', width: '140px', fontSize: '13px' }}>Date of Event:</label>
                                <span style={{ textDecoration: 'none' }}>{bill.eventDetails?.dateOfEvent ? formatDate(bill.eventDetails.dateOfEvent) : '____________________'}</span>
                            </div>
                            <div style={{ marginBottom: '5px' }}>
                                <label style={{ display: 'inline-block', width: '140px', fontSize: '13px' }}>1. Ladies:</label>
                                <span style={{ textDecoration: 'none' }}>{bill.eventDetails?.ladies || '________________________'}</span>
                            </div>
                            <div style={{ marginBottom: '5px' }}>
                                <label style={{ display: 'inline-block', width: '140px', fontSize: '13px' }}>2. Gents:</label>
                                <span style={{ textDecoration: 'none' }}>{bill.eventDetails?.gents || '_________________________'}</span>
                            </div>
                            <div style={{ marginBottom: '5px' }}>
                                <label style={{ display: 'inline-block', width: '140px', fontSize: '13px' }}>3. Venue:</label>
                                <span style={{ textDecoration: 'none' }}>{bill.eventDetails?.venue || '_________________________'}</span>
                            </div>
                        </div>

                        
                        <div>
                            <div style={{ marginBottom: '5px' }}>
                                <label style={{ display: 'inline-block', width: '140px', fontSize: '13px' }}>CNIC No:</label>
                                <span style={{ textDecoration: 'none' }}>{bill.eventDetails?.cnic || '__________________________'}</span>
                            </div>
                            <div style={{ marginBottom: '5px' }}>
                                <label style={{ display: 'inline-block', width: '140px', fontSize: '13px' }}>Day of Event:</label>
                                <span style={{ textDecoration: 'none' }}>{bill.eventDetails?.dayOfEvent || '_____________________'}</span>
                            </div>

                            <div style={{ marginBottom: '5px' }}>
                                <label style={{ display: 'inline-block', width: '140px', fontSize: '13px' }}>Lunch/Dinner:</label>
                                <span style={{ textDecoration: 'none' }}>{bill.eventDetails?.lunchDinner || '____________________'}</span>
                            </div>
                            <div style={{ marginBottom: '5px' }}>
                                <label style={{ display: 'inline-block', width: '140px', fontSize: '13px' }}>No of Persons:</label>
                                <span style={{ textDecoration: 'none' }}>{bill.eventDetails?.persons || '___________________'}</span>
                            </div>

                             <div style={{ marginBottom: '5px' }}>
                                <label style={{ display: 'inline-block', width: '140px', fontSize: '13px' }}>Type of Service:</label>
                                <span style={{ textDecoration: 'none' }}>{bill.serviceType || '___________________'}</span>
                            </div>
                        </div>
                    </div>

                 
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '15px',
                        marginTop: '8px'
                    }}>
                       
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            fontSize: '12px'
                        }}>
                            <thead>
                                <tr>
                                    <th colSpan="2" style={{
                                        border: '1px solid #777',
                                        padding: '5px 6px',
                                        backgroundColor: '#f2f2f2',
                                        textAlign: 'left'
                                    }}>Bill Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ border: '1px solid #777', padding: '5px 6px' }}>Food Bill</td>
                                    <td style={{ border: '1px solid #777', padding: '5px 6px' }}>{formatCurrency(bill.billDetails?.foodBill)}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #777', padding: '5px 6px' }}>DJ (Music)</td>
                                    <td style={{ border: '1px solid #777', padding: '5px 6px' }}>{formatCurrency(bill.billDetails?.djMusic)}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #777', padding: '5px 6px' }}>Service Charges</td>
                                    <td style={{ border: '1px solid #777', padding: '5px 6px' }}>{formatCurrency(bill.billDetails?.serviceCharges)}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #777', padding: '5px 6px' }}>Hall Rent</td>
                                    <td style={{ border: '1px solid #777', padding: '5px 6px' }}>{formatCurrency(bill.billDetails?.hallRent)}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #777', padding: '5px 6px' }}>BWD (Decore)</td>
                                    <td style={{ border: '1px solid #777', padding: '5px 6px' }}>{formatCurrency(bill.billDetails?.bwdStage)}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #777', padding: '5px 6px' }}>AC Charges</td>
                                    <td style={{ border: '1px solid #777', padding: '5px 6px' }}>{formatCurrency(bill.billDetails?.acCharges)}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #777', padding: '5px 6px' }}>Heater Charges</td>
                                    <td style={{ border: '1px solid #777', padding: '5px 6px' }}>{formatCurrency(bill.billDetails?.heaterCharges)}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #777', padding: '5px 6px' }}>Ladies Waiter</td>
                                    <td style={{ border: '1px solid #777', padding: '5px 6px' }}>{formatCurrency(bill.billDetails?.ladiesWaiter)}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #777', padding: '5px 6px' }}>Govt.Tax 5%</td>
                                    <td style={{ border: '1px solid #777', padding: '5px 6px' }}>{formatCurrency(bill.billDetails?.govtTax)}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #777', padding: '5px 6px' }}>Other Charges</td>
                                    <td style={{ border: '1px solid #777', padding: '5px 6px' }}>{formatCurrency(bill.billDetails?.otherCharges)}</td>
                                </tr>
                                <tr>
                                    <th style={{ border: '1px solid #777', padding: '5px 6px', backgroundColor: '#f2f2f2' }}>Total Payment</th>
                                    <th style={{ border: '1px solid #777', padding: '5px 6px', backgroundColor: '#f2f2f2' }}>{formatCurrency(bill.billDetails?.totalAmount)}</th>
                                </tr>
                                <tr>
                                    <th style={{ border: '1px solid #777', padding: '5px 6px', backgroundColor: '#f2f2f2' }}>Received Payment</th>
                                    <th style={{ border: '1px solid #777', padding: '5px 6px', backgroundColor: '#f2f2f2' }}>{formatCurrency(bill.eventDetails?.advancePayment)}</th>
                                </tr>
                                <tr>
                                    <th style={{ border: '1px solid #777', padding: '5px 6px', backgroundColor: '#f2f2f2' }}>Remaining Payment</th>
                                    <th style={{ border: '1px solid #777', padding: '5px 6px', backgroundColor: '#f2f2f2' }}>{formatCurrency(bill.billDetails?.remainingAmount)}</th>
                                </tr>
                            </tbody>
                        </table>


                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            fontSize: '12px'
                        }}>
                            <thead>
                                <tr>
                                    <th style={{
                                        border: '1px solid #777',
                                        padding: '5px 6px',
                                        backgroundColor: '#f2f2f2',
                                        textAlign: 'left'
                                    }}>Menu</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bill.menu && bill.menu.length > 0 ? (
                                    bill.menu.map((item, index) => (
                                        item.item && item.item.trim() !== '' && (
                                            <tr key={index}>
                                                <td style={{ border: '1px solid #777', padding: '5px 6px' }}>
                                                    {item.item} 
                                                </td>
                                            </tr>
                                        )
                                    ))
                                ) : (
                                    <>
                                        {[...Array(6)].map((_, index) => (
                                            <tr key={index}>
                                                <td style={{ border: '1px solid #777', padding: '5px 6px' }}>&nbsp;</td>
                                            </tr>
                                        ))}
                                    </>
                                )}
                                <tr>
                                    <td style={{ border: '1px solid #777', padding: '5px 6px' }}>
                                        <strong>Per Head:</strong> {formatCurrency(bill.perHead)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>


                    <div style={{ marginTop: '12px', fontSize: '13px' }}>
                        <div style={{ marginBottom: '5px' }}>
                            <label style={{ display: 'inline-block', width: '140px', fontSize: '13px' }}>Mob No 1:</label>
                            <span style={{ textDecoration: 'none' }}>{bill.eventDetails.mob1 || '_______________________'}</span>
                        </div>
                        <div style={{ marginBottom: '5px' }}>
                            <label style={{ display: 'inline-block', width: '140px', fontSize: '13px' }}>Mob No 2:</label>
                            <span style={{ textDecoration: 'none' }}>{bill.eventDetails.mob2 || '_______________________'}</span>
                        </div>
                    </div>


                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginTop: '15px'
                    }}>
                        <div style={{ width: '48%' }}>
                            <label style={{ fontSize: '13px' }}>Sign of Customer:</label>
                            <div style={{ height: '25px', borderBottom: '1px solid #000', marginTop: '3px' }}></div>
                        </div>
                        <div style={{ width: '48%', textAlign: 'right' }}>
                            <label style={{ fontSize: '13px' }}>Sign of Manager:</label>
                            <div style={{ height: '25px', borderBottom: '1px solid #000', marginTop: '3px' }}></div>
                        </div>
                    </div>


                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        borderTop: '1px solid #ccc',
                        marginTop: '15px',
                        paddingTop: '8px',
                        fontSize: '11px'
                    }}>

                        <div style={{ width: '48%' }}>
                            <p style={{ margin: '2px 0', fontWeight: 'bold', textAlign: 'left' }}>
                                RONAQ BANQUETS
                            </p>
                            <p style={{ margin: '2px 0', textAlign: 'left' }}>
                                <strong>Address:</strong>
                            </p>
                            <p style={{ margin: '2px 0', textAlign: 'left' }}>
                                Main NUST Double Road, OPP. Gate # H13
                            </p>
                            <p style={{ margin: '2px 0', textAlign: 'left' }}>
                                Islamabad , Pakistan
                            </p>
                        </div>


                        <div style={{ width: '48%', textAlign: 'right' }}>
                            <p style={{ margin: '2px 0', fontWeight: 'bold', textAlign: 'right' }}>
                                CONTACT US
                            </p>
                            <p style={{ margin: '2px 0', textAlign: 'right' }}>
                                <strong>Mananger Phone:</strong> 0315-5530667
                            </p>
                            <p style={{ margin: '2px 0', textAlign: 'right' }}>
                                <strong>Mobile:</strong> 0332-9911223 | 0332-5412237
                            </p>
                            {/* <p style={{ margin: '2px 0', textAlign: 'right' }}>
                                <strong>Email:</strong> info@ronaqmarquee.com
                            </p> */}
                            <p style={{ margin: '2px 0', textAlign: 'right' }}>
                                <strong>Website:</strong> www.ronaqbanquets.com
                            </p>
                        </div>
                    </div>
                </div>


                <div className="d-print-none mt-4 text-center">
                    <Button
                        variant="outline-secondary"
                        onClick={() => navigate('/admin/dashboard/bills-list')}
                        className="me-3"
                    >
                        <FaArrowLeft className="me-2" />
                        Back to Bills List
                    </Button>

                    <Button
                        variant="success"
                        onClick={handlePrint}
                        className="me-3"
                    >
                        <FaPrint className="me-2" />
                        Print Bill
                    </Button>
                    <Button
                        variant="dark"
                        onClick={handleDownloadPDF}
                    >
                        <FaDownload className="me-2" />
                        Download PDF
                    </Button>
                </div>
            </Container>


            <style>
                {`
          /* Hide everything except bill content when printing */
          @media print {
            body * {
              visibility: hidden !important;
              margin: 0 !important;
              padding: 0 !important;
            }
            
            #bill-content, #bill-content * {
              visibility: visible !important;
              position: relative;
              z-index: 1;
            }
            
            #bill-content {
              position: absolute !important;
              left: 0 !important;
              top: 0 !important;
              width: 100% !important;
              max-width: 100% !important;
              padding: 15px 20px !important;
              margin: 0 !important;
              border: none !important;
              min-height: auto !important;
              background: white !important;
              z-index: 1;
            }
            
            .d-print-none {
              display: none !important;
            }
          }
          
          /* Page settings */
          @page {
            size: A4;
            margin: 15mm;
          }
          
          body {
            background: #f5f5f5 !important;
          }
        `}
            </style>
        </Layout>
    );
};

export default ViewBill;